import React, { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../ui/dialog";
import Button from "../../form/button";
import { Input } from "../../ui/input";
import { IExpenseType, ITheme, Status } from "../../../lib/types";
import { useFontAwesomeIconPack } from "../../../hooks/useFontAwesomeIconPack";
import ThemeSelect from "../../form/ThemeSelect";
import { IconLookup } from "@fortawesome/fontawesome-svg-core";
import { cn } from "../../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconSelectField } from "../../form/IconSelect";
import { slateTheme } from "../../../lib/consts";
import pb from "../../../lib/pocketbase";
import ErrorMessage from "../../form/errorMessage";

interface INewCategoryProps {
    reload?: () => void;
}

export default function NewCategory({ reload }: INewCategoryProps) {
    const icons = useFontAwesomeIconPack();
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [status, setStatus] = useState<Status>("none");
    const [icon, setIcon] = useState<IconLookup>();
    const [theme, setTheme] = useState<ITheme | undefined>(slateTheme);
    const [error, setError] = useState("");

    function add() {
        if (!pb.authStore.model) return;
        setStatus("loading");
        const data: IExpenseType = {
            name: name,
            icon: icon,
            theme: theme,
            user: pb.authStore.model.id,
            default: false
        };

        pb.collection("expenseType")
            .create(data)
            .then(() => {
                setTimeout(() => {
                    setStatus("success");
                    setError("");
                    reload && reload();
                    setOpen(false);
                }, 500);
            })
            .catch((err: Error) => {
                setStatus("error");
                setError(err.message);
            })
            .finally(() => {
                setTimeout(() => {
                    setStatus("none");
                }, 3000);
            });
    }
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                    Add category
                </Button>
            </DialogTrigger>
            <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>Add category</DialogTitle>
                </DialogHeader>
                <ErrorMessage error={error} close={() => setError("")} />

                <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Category name" />

                <ThemeSelect theme={theme} onChange={(x) => setTheme(x)} />
                <IconSelectField icon={icon} onChange={(i) => setIcon(i)} icons={icons} label="Choose an icon: " />

                <div>
                    <span>Preview: </span>
                    <div className={cn(theme?.background, theme?.foreground, "flex h-12 w-12 items-center justify-center rounded-lg font-medium")}>{icon ? <FontAwesomeIcon icon={icon} size="lg" /> : name.charAt(0).toUpperCase() || "X"}</div>
                </div>

                <DialogFooter className="gap-2">
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button status={status} onClick={() => add()} variant="dark">
                        {status === "loading" && "Adding"}
                        {status === "success" && "Added"}
                        {status === "error" && "Error"}
                        {status === "none" && "Add"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
